import React from 'react';
import { useSearchParams } from 'react-router-dom';
import ProjectList from './ProjectList';
import AccountingDashboard from './AccountingDashboard';
import { SegmentedControl } from '../components/ui';
import { DASHBOARD_OPTIONS, dashboardViewOf } from '../lib/dashboards';

/* The Dashboard route: the person's dashboard (lib/dashboards.js -- their own setting, else their role's),
   and for an admin a switch between them. */
const Dashboard = ({ currentUser, onSelectProject }) => {
  const [params, setParams] = useSearchParams();
  const view = dashboardViewOf(currentUser, params);
  const canSwitch = !!currentUser && currentUser.role === 'admin';
  return (
    <>
      {canSwitch && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 14 }}>
          <span style={{ fontSize: 13.5, fontWeight: 500, color: 'var(--text-3)' }}>Dashboard</span>
          <SegmentedControl
            value={view}
            onChange={(v) => setParams({ view: v }, { replace: true })}
            options={DASHBOARD_OPTIONS}
          />
        </div>
      )}
      {view === 'accounting'
        ? <AccountingDashboard currentUser={currentUser} onSelectProject={onSelectProject} />
        : <ProjectList currentUser={currentUser} onSelectProject={onSelectProject} />}
    </>
  );
};

export default Dashboard;
